module.exports = __webpack_public_path__ + "media/budgeting_calculators/fin_aid_advice-408cdb20.png";